var map = {
	"./template.bet575": 1555,
	"./template.bet575.tsx": 1555,
	"./template.bet777": 1556,
	"./template.bet777.tsx": 1556,
	"./template.betprofessor": 1557,
	"./template.betprofessor.tsx": 1557,
	"./template.betroyale": 1558,
	"./template.betroyale.tsx": 1558,
	"./template.betstride": 1559,
	"./template.betstride.tsx": 1559,
	"./template.buffalobet": 1560,
	"./template.buffalobet.tsx": 1560,
	"./template.chromabet": 1561,
	"./template.chromabet.tsx": 1561,
	"./template.default": 669,
	"./template.default.tsx": 669,
	"./template.epicodds": 1562,
	"./template.epicodds.tsx": 1562,
	"./template.fiestabet": 1563,
	"./template.fiestabet.tsx": 1563,
	"./template.gigabet": 1564,
	"./template.gigabet.tsx": 1564,
	"./template.goldenbet888": 1565,
	"./template.goldenbet888.tsx": 1565,
	"./template.goldenrush": 1566,
	"./template.goldenrush.tsx": 1566,
	"./template.hyperbet": 1567,
	"./template.hyperbet.tsx": 1567,
	"./template.juicybet": 1568,
	"./template.juicybet.tsx": 1568,
	"./template.junglebet": 1569,
	"./template.junglebet.tsx": 1569,
	"./template.magnumbet": 1570,
	"./template.magnumbet.tsx": 1570,
	"./template.puntcity": 1571,
	"./template.puntcity.tsx": 1571,
	"./template.questbet": 1572,
	"./template.questbet.tsx": 1572,
	"./template.slambet": 1573,
	"./template.slambet.tsx": 1573,
	"./template.templebet": 1574,
	"./template.templebet.tsx": 1574,
	"./template.titanbet": 1575,
	"./template.titanbet.tsx": 1575,
	"./template.ts": 981,
	"./template.vikingbet": 1576,
	"./template.vikingbet.tsx": 1576,
	"./template.volcanobet": 1577,
	"./template.volcanobet.tsx": 1577,
	"./template.wellbet": 1578,
	"./template.wellbet.tsx": 1578
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2447;